import {Component, HostListener, Input} from '@angular/core';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
// import { CartCalculationService } from 'src/app/cart/service/cart-calculation.service';
import {FinishProfile} from 'src/app/product-details/interface/finish-profile';
import {FinishProfileItem} from 'src/app/product-details/interface/finish-profile-item-list';
import {PriceCalculationService} from 'src/app/product-details/service/price-calculation.service';
import {GlobalService} from 'src/app/services/global.service';

@Component({
	selector: 'fb-select-finish',
	templateUrl: './select-finish.component.html',
	styleUrls: ['./select-finish.component.scss']
})

export class SelectFinishComponent {

	constructor(
		private _priceCalculation: PriceCalculationService,
		private _globalService: GlobalService,
		private _cartCalculation: CartCalculationService
	) {

	}
	@Input() finishProfileData: FinishProfile = {} as FinishProfile;
	@Input() instockIds: string | undefined = '';
	@Input() madeToOrderFabricId: number | undefined;
	@Input() productId: number = 0;
	public instockIdsParsed: string[] = []
	public closeFinishOption: boolean = false;
	public isMoreSelected: boolean = false;
	public finishProfileList: FinishProfileItem[] = [];
	public finishProfileListMoreThan4: FinishProfileItem[] = [];
	public deltaIndex:number = 0;
	public previousDeltaIndex:number = 0;
	public allSelectedFinishedData: FinishProfileItem[] = []; // more data and this component selected data
	public deltaIndexForMoreInfo: number = -1;
	public selectedFinishedData: FinishProfileItem[] = [];

	public showFinishMoreOption(): void {
		this.closeFinishOption = true;
		this._globalService.popUpOpenClose(true);
	}

	public selectFinishOption(i: number): void {

		this.deltaIndex = i;
		this.previousDeltaIndex = i;

		// console.log(this.finishProfileList[i])

		if (this.finishProfileList[i].checked == true) {
			this.finishProfileList[i].checked = false;
			// this._cartCalculation.inStockFinishPrice -= this.finishProfileList[i].price;
		}
		else {
			this.finishProfileList[i].checked = true;
			// this._cartCalculation.inStockFinishPrice += this.finishProfileList[i].price;

		}

		let tempArray: FinishProfileItem[] = [...this.allSelectedFinishedData]
		this.allSelectedFinishedData = [...tempArray, ...this.finishProfileList, ...this.finishProfileListMoreThan4]
		this.allSelectedFinishedData = [...this.removeDuplicate(this.allSelectedFinishedData)];

		this._cartCalculation.zeroElementFinish = [];

		this._cartCalculation.selectedFinishForCartCalc = [];
		this.allSelectedFinishedData.forEach((element: FinishProfileItem, i: number) => {

			if (element.checked) {
				this._priceCalculation.selectedFinish.push(element);
				this._cartCalculation.zeroElementFinish.push(element);
				this._cartCalculation.selectedFinishForCartCalc.push(element);
			}

		});

		this.selectedFinishedData = [...this.removeDuplicate(this.allSelectedFinishedData).filter(
			(elm:FinishProfileItem) => elm.checked)
		];

		setTimeout(() => {
			this._priceCalculation.calculatePrice(true, false, 'select-finish');

		}, 0); // pass data for price calc


	}

	public onLoadSelectedFinishItem(): void {
		// debugger
		this._cartCalculation.selectedFinishForCartCalc = []
		let id = this.instockIds ? this.instockIds : '';
		this.instockIdsParsed = id.split(",");

		this.finishProfileData.finishProfileItemList.forEach((elm: FinishProfileItem) => {
			this.instockIdsParsed.forEach((id: string) => {
				if (+id == elm.id) {
					elm.checked = true;
					elm.inStock = true;
					elm.instockInNumber = 1;
					this._priceCalculation.selectedFinish.push(elm);
					this._cartCalculation.selectedFinishForCartCalc.push(elm);
					this.allSelectedFinishedData.push(elm);
				}
			});
		});



		let sortedInsockFinished = this.finishProfileData.finishProfileItemList.sort(
			(a:FinishProfileItem, b:FinishProfileItem)=> b.instockInNumber! - a.instockInNumber!  )


		this.finishProfileData.finishProfileItemList = sortedInsockFinished;

		if (!this.instockIds) {

			this.deltaIndex = -1;
			// this._priceCalculation.inStockIdsParsed = [
			// 	this.finishProfileData.finishProfileItemList[0].id + ''
			// ];
			// this._priceCalculation.selectedFinish = [this.finishProfileData.finishProfileItemList[0]];
		}
		else {
			this._priceCalculation.inStockIdsParsed = this.instockIdsParsed;
		}

		this.selectedFinishedData = sortedInsockFinished.filter((elm:FinishProfileItem) => elm.checked);

		// console.log(this.finishProfileData.finishProfileItemList)

	}

	public ngOnInit(): void {

		this.finishProfileData.finishProfileItemList.forEach((elm: FinishProfileItem, i: number) => {
			elm['checked'] = false;
			elm['inStock'] = false;
			elm.instockInNumber = 0;
		})
		// debugger
		this.onLoadSelectedFinishItem();

		this.finishProfileData.finishProfileItemList.forEach((elm: FinishProfileItem, i: number) => {

			if (i <= 3) {

				this.finishProfileList.push(elm);
				this.finishProfileListMoreThan4.push(elm);

			}
			if (i > 3) {
				this.finishProfileListMoreThan4.push(elm);
			}

		});





		this.allSelectedFinishedData.push(this.finishProfileList[0]); //:TODO // if problem? uncomment

		let instockPriceOnLoad: number[] = [];
		this.finishProfileData.finishProfileItemList.forEach(elm => {
			if (elm.checked) {
				instockPriceOnLoad.push(elm.price);
			}
		});

		let priceTotal = instockPriceOnLoad.reduce(function (prev, cur) {
			return prev + cur;
		}, 0);

		this._priceCalculation.inStockFinishPrice = priceTotal;
		this._cartCalculation.inStockFinishPrice = priceTotal;


		if( !this._priceCalculation.makingCharges && (this.madeToOrderFabricId !== this.productId)) {
			setTimeout(() => this._priceCalculation.calculatePrice(true, true, 'select-finish'), 0);
		}
		else {
			setTimeout(() => this._priceCalculation.calculatePrice(true, false, 'select-finish'), 0);
		}
		this._cartCalculation.orderType = 'IN_STOCK';

	}

	public moreFabricnfo(i: number): void {
		// debugger
		// this.deltaIndex = i;
		this.deltaIndexForMoreInfo = i;

		// this.closeInfo = true;
	}

	public moreFinishRemove(e: any): void {
		// this.deltaIndex = this.previousDeltaIndex;
		this.deltaIndexForMoreInfo = -1;
		// this.closeInfo = false;
		e.stopPropagation()
	}


	public closeFinishedClicked(): void {
		this.closeFinishOption = false;
		this.deltaIndex = this.previousDeltaIndex;
		this._globalService.popUpOpenClose(false);

		this.selectedFinishedData = [...this.removeDuplicate(this.finishProfileList).filter(
			(elm:FinishProfileItem) => elm.checked)
		];

	}


	public continueFinishedClicked(data: FinishProfileItem[]): void {

		if (data.length) this.isMoreSelected = true; else this.isMoreSelected = false;
		// debugger
		let tempArray: FinishProfileItem[] = [...this.allSelectedFinishedData];
		this.allSelectedFinishedData = [...tempArray, ...data];


		// console.log(this.allSelectedFinishedData)
		this.allSelectedFinishedData = [...this.removeDuplicate(this.allSelectedFinishedData)];
		// console.log(this.allSelectedFinishedData)

		this.finishProfileList = [];
		this._cartCalculation.selectedFinishForCartCalc = [];
		// this._priceCalculation.selectedFinish = [];

		this.allSelectedFinishedData.forEach((element: FinishProfileItem, i: number) => {

			if (element.checked) {
				this._priceCalculation.selectedFinish.push(element);

				if( !this.finishProfileList.some((elm) => element.id == elm.id)){
					this.finishProfileList.push(element);
					this._cartCalculation.selectedFinishForCartCalc.push(element);
					// this._priceCalculation.selectedFinish.push(element);
				}
			}
		});
		// this.finishProfileList = [...unSelectedFinishedInOuter]

		this.selectedFinishedData = [...this.removeDuplicate(this.finishProfileList).filter(
			(elm:FinishProfileItem) => elm.checked)
		];
		setTimeout(() => this._priceCalculation.calculatePrice(true, false, 'select-finish'), 0);

		this.closeFinishOption = false;
	}

	public removeDuplicate(arr: FinishProfileItem[]): FinishProfileItem[] {
		const ids = arr.map(o => o.id); // remove duplicate
		const filtered = arr.filter(({ id }, index) => !ids.includes(id, index + 1));
		return filtered;
	}


	@HostListener('document:click', ['$event'])
	public clickout() {
	this.deltaIndexForMoreInfo = -1;
	}

	// @HostListener('window:scroll', ['$event'])
	// public scrollHandler(): void {
	// 	this.deltaIndexForMoreInfo = -1;
	// }


}
